import React, { createContext, useCallback, useContext, useState } from 'react';

const MobilePanelContext = createContext({
  mobilePanel: null,
  setMobilePanel: () => {},
  closeMobilePanel: () => {},
});

export function MobilePanelProvider({ children }) {
  const [mobilePanel, setMobilePanel] = useState(null);
  const closeMobilePanel = useCallback(() => setMobilePanel(null), []);

  return (
    <MobilePanelContext.Provider value={{ mobilePanel, setMobilePanel, closeMobilePanel }}>
      {children}
    </MobilePanelContext.Provider>
  );
}

export function useMobilePanel() {
  return useContext(MobilePanelContext);
}

export default MobilePanelContext;
